// console.log(style);
// import "./_checkout/checkout";
import "./customs/checkout/_autoload";
import "./booking-form-mobile";
import "./booking-confirmation-text";
import "./sticky-header";
import "./home-villa-toggle";
